module.exports = __webpack_public_path__ + "img/logo-gex.db4bf60f.png";